import { useFormikContext } from "formik";
import React, { FC } from "react";
import { TextButton, Button } from "./Button.style";

export interface IWrapButton {
  title: string;
  disabled: boolean;
  isLoading?: boolean;
  onClick?:
    | ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
    | undefined;
}

const WrapButton: FC<IWrapButton> = (props) => {
  const { isSubmitting } = useFormikContext();

  const isLoading = isSubmitting || props.isLoading;

  return (
    <Button {...props}>
      {(props.disabled || isLoading) && (
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      )}
      {!props.disabled && !isLoading && <TextButton>{props.title}</TextButton>}
    </Button>
  );
};

export default WrapButton;
